import React, { createContext, useContext, useEffect, useState } from 'react';

export type ScreenViewType = 'desktop' | 'tablet' | 'mobile';

interface ScreenViewContextType {
  screenView: ScreenViewType;
  setScreenView: (view: ScreenViewType) => void;
}

const ScreenViewContext = createContext<ScreenViewContextType | undefined>(
  undefined
);

export function ScreenViewProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [screenView, setScreenView] = useState<ScreenViewType>('desktop');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1480 && window.innerWidth >= 600) {
        setScreenView('tablet');
      } else if (window.innerWidth < 600) {
        setScreenView('mobile');
      } else {
        setScreenView('desktop');
      }
    };

    // Set initial value
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ScreenViewContext.Provider value={{ screenView, setScreenView }}>
      {children}
    </ScreenViewContext.Provider>
  );
}

export function useScreenView() {
  const context = useContext(ScreenViewContext);
  if (context === undefined) {
    throw new Error('useScreenView must be used within a ScreenViewProvider');
  }
  return context;
}
